import { Component } from '@angular/core';
import { getProtocolHostnameAndPort } from '@app/shared/helpers/location';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-smash-trustpilot',
  templateUrl: './smash-trustpilot.component.html',
  styleUrls: ['./smash-trustpilot.component.scss']
})
export class SmashTrustpilotComponent {
  expand = false;

  constructor(private translateService: TranslateService,) { }

  redirect(targetProfile: string) {
    window.open(
      getProtocolHostnameAndPort() + '/redirect?url=' + encodeURIComponent(this.translateService.instant(targetProfile)),
      '_blank'
    );
  }

}
